// APP
export const OPEN_DIALOG = "OPEN_DIALOG";
export const HIDE_DIALOG = "HIDE_DIALOG";

export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const HIDE_NOTIFICATION = "HIDE_NOTIFICATION";

export const AUTH_SIGN_OUT = "AUTH_SIGN_OUT";

// Theme
export const THEME_SET = "THEME_SET";
export const THEMES = {
  DEFAULT: "DEFAULT",
  DARK: "DARK",
  LIGHT: "LIGHT",
  BLUE: "BLUE",
  GREEN: "GREEN",
  INDIGO: "INDIGO",
  RED: "RED"
};

export const GET_ORG_WEBSITE_SUCCESS = "GET_ORG_WEBSITE_SUCCESS";
export const GET_ORG_WEBSITE_ERROR = "GET_ORG_WEBSITE_ERROR";

// Generate code
export const GENERATECODE_INIT = "GENERATECODE_INIT";
export const GENERATECODE_SUCCESS = "GENERATECODE_SUCCESS";
export const GENERATECODE_ERROR = "GENERATECODE_ERROR";

// Confirm code
export const CONFIRMCODE_SUCCESS = "CONFIRMCODE_SUCCESS";
export const CONFIRMCODE_ERROR = "CONFIRMCODE_ERROR";

// Overview Subscriptions
export const GET_PLANS = "GET_PLANS";
export const GET_PLANS_SUCCESS = "GET_PLANS_SUCCESS";
export const GET_PLANS_ERROR = "GET_PLANS_ERROR";

export const GET_SUBSCRIPTION_EVENTS = "GET_SUBSCRIPTION_EVENTS";
export const GET_SUBSCRIPTION_EVENTS_SUCCESS = "GET_SUBSCRIPTION_EVENTS_SUCCESS";
export const GET_SUBSCRIPTION_EVENTS_ERROR = "GET_SUBSCRIPTION_EVENTS_ERROR";


//AUTH
export const AUTH_SIGN_IN_REQUEST = "AUTH_SIGN_IN_REQUEST";
export const AUTH_SIGN_IN_SUCCESS = "AUTH_SIGN_IN_SUCCESS";
export const AUTH_SIGN_IN_FAILURE = "AUTH_SIGN_IN_FAILURE";
